import React from "react";
import { CreatableAutocompleteAsync, Option } from "../../common/autocomplete";
import { useMixerFlavor } from "./useMixerFlavor";

interface MixerFlavorCreatableAutocompleteProps {
    onSelectFlavor: (option: Option) => void;
    selectedFlavorOption?: Option;
}

export const MixerFlavorCreatableAutocomplete: React.FC<MixerFlavorCreatableAutocompleteProps> = ({
    onSelectFlavor,
    selectedFlavorOption,
}) => {
    const { options, isLoading, onChangeInput, onSelect, searchString } = useMixerFlavor();

    const handleSelect = (index: number) => {
        onSelectFlavor(options[index]);
        onSelect(index);
    };

    return (
        <CreatableAutocompleteAsync
            isLoading={isLoading}
            options={options}
            onChangeInput={onChangeInput}
            selectedOption={selectedFlavorOption}
            placeholder="Start typing..."
            onSelect={handleSelect}
            value={searchString}
        />
    );
};
